import { CrudService } from './CrudService';
import { resources } from '../resources';
import { SupplierQueryParams } from '../params/SupplierQueryParams';
import { SupplierDto } from '../models/suppliers/SupplierDto';
import { SupplierBasicDto } from '../models/suppliers/SupplierBasicDto';
import { SupplierRequest } from '../models/suppliers/SupplierRequest';
import { ReferenceDto } from '../models/employees/ReferenceDto';
import { Args, AxiosConfig, AxiosPagePromise } from './BaseService';
import { Page } from '../models/common/Page';
import { AxiosPromise } from 'axios';

export class SupplierService extends CrudService<SupplierDto, SupplierQueryParams> {
  constructor() {
    super({
      query: resources.querySuppliers,
      get: resources.getSupplier,
      create: resources.createSupplier,
      update: resources.updateSupplier,
      idKey: 'supplierId',
    });
  }

  public queryLendableSuppliers(args?: SupplierQueryParams, options: AxiosConfig = {}): AxiosPagePromise<SupplierDto> {
    return this.get<Page<SupplierDto>>(resources.queryLendableSuppliers, args as Args, options);
  }

  public getSupplierBasic(supplierId: string, args?: Args, options?: AxiosConfig): AxiosPromise<SupplierBasicDto> {
    return this.get<SupplierBasicDto>(resources.getSupplierBasic, { ...args, supplierId }, options);
  }

  public requestSupplier(invitationId: string, payload: SupplierRequest, args?: Args): AxiosPromise<ReferenceDto> {
    return this.post<ReferenceDto>(resources.requestSupplier, payload, { ...args, invitationId });
  }

  public approveSupplier(supplierId: string, args?: Args): AxiosPromise<void> {
    return this.post<void>(resources.approveSupplier, undefined, { ...args, supplierId });
  }

  public async deleteRequestedSupplier(supplierId: string, args?: Args): Promise<boolean> {
    const response = await this.delete<void>(resources.deleteRequestedSupplier, { ...args, supplierId });
    return response.status !== 0;
  }
}
